import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/AddUnit.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.milstudio.in';

const AddChair = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [chairNumber, setChairNumber] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [isEditMode, setIsEditMode] = useState(false);

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 3000);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const chairId = urlParams.get('id');
    
    if (chairId) {
      setIsEditMode(true);
      if (location.state && location.state.chair) {
        setChairNumber(location.state.chair.chairname);
      } else {
        fetchChairData(chairId);
      }
    } else {
      setIsEditMode(false);
      setChairNumber('');
    }
  }, [location.search, location.state]);

  const fetchChairData = async (chairId) => {
    try {
      const response = await fetch(`${API_URL}get-chair.php?id=${chairId}`);
      const data = await response.json();
      if (data.chair) {
        setChairNumber(data.chair.chairname);
      }
    } catch (error) {
      showToast('Error loading chair data', 'error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!chairNumber.trim()) {
      showToast('Please enter a chair number', 'error');
      return;
    }
    setIsSubmitting(true);
    try {
      let apiUrl = `${API_URL}add-chair.php`;
      let requestBody = { chairname: chairNumber };

      if (isEditMode) {
        const urlParams = new URLSearchParams(location.search);
        const chairId = urlParams.get('id');
        apiUrl = `${API_URL}edit-chair.php`;
        requestBody = {
          chair_id: chairId,
          chairname: chairNumber
        };
      }

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.status) {
        showToast(`Chair "${chairNumber}" ${isEditMode ? 'updated' : 'added'} successfully!`, 'success');
        if (!isEditMode) {
          setChairNumber('');
        }
        setTimeout(() => {
          navigate('/chair-list');
        }, 1500);
      } else {
        showToast(data.message || `Error ${isEditMode ? 'updating' : 'adding'} chair. Please try again.`, 'error');
      }
    } catch (error) {
      showToast(`Error ${isEditMode ? 'updating' : 'adding'} chair. Please try again.`, 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-chair-content">
      <div className="page-header" style={{display: 'block'}}>
        <h1>{isEditMode ? 'Edit Chair' : 'Add Chair'}</h1>
        <p>{isEditMode ? 'Update chair information' : 'Add a new chair to your restaurant'}</p>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-unit-form">
          <div className="form-group">
            <label htmlFor="chairNumber">Chair Number</label>
            <input
              type="text"
              id="chairNumber"
              name="chairNumber"
              value={chairNumber}
              onChange={(e) => setChairNumber(e.target.value)}
              placeholder="Enter chair number (e.g., 1, 2, C-1)"
              required
              disabled={isSubmitting}
            />
          </div>
          <button 
            type="submit" 
            className="submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? (isEditMode ? 'Updating Chair...' : 'Adding Chair...') : (isEditMode ? 'Update Chair' : 'Add Chair')}
          </button>
        </form>
      </div>
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button 
              className="toast-close" 
              onClick={() => setToast({ show: false, message: '', type: '' })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddChair; 